import { Form, Input, Button, message } from 'antd';
import './index.scss';
import { http } from '../../utils';
import md5 from 'js-md5';

const Setting = () => {
  
  const [form] = Form.useForm();

  
  const validatePasswordConfirm = ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('passwd') === value) {
        return Promise.resolve(); // 密码一致，校验通过
      }
      return Promise.reject('The passwords entered twice are inconsistent.'); // 密码不一致，校验失败
    },
  });
  
  
  const onFinish = async (values) => {
    const { passwd } = values;
    let passwdMd5 = md5(md5(passwd + 'twy-service'));
    
    const { code } = await http.post(`/api/user/update`, {
      passwd: passwdMd5
    });
    
    if (parseInt(code, 10) === 0) {
      message.success('update success');
      form.resetFields();
    } else {
      message.error('update error');
    }
  }
  
  return (
    <div>
      <div className="setting-header">Setting</div>
      <Form
        form={form}
        labelCol={{
          span: 3,
        }}
        onFinish={ onFinish }
      >
        <Form.Item
          label="Password"
          name="passwd"
          rules={[
            {
              required: true,
              message: 'Please input your password!',
            },
            {
              max: 16, // 最大字符长度为50
              message: 'password length cannot exceed 16 characters',
            },
            {
              min: 8, // 最小字符长度为5
              message: 'password length cannot be less than 8 characters',
            },
          ]}
        >
          <Input.Password />
        </Form.Item>
        
        <Form.Item
          label="Password comfirm"
          name="passwd2"
          rules={[
            {
              required: true,
              message: 'Please input your password comfirm!',
            },
            validatePasswordConfirm
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          wrapperCol={{
            offset: 3,
          }}
        >
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}

export default Setting;